import { Tag } from 'primereact/tag';

import EmissionValueWithSuffix from '../../../../../../../../../../../../../../shared/components/emission-value-with-suffix/EmissionValueWithSuffix';
import { EmissionSymbol } from '../../../../../../../../../../../../../../shared/interfaces/IFootprint';
import { IInputMaterial } from '../../../../../../PcfWizard.type';
import RemoveProcessButton from '../../../../RemoveProcessButton';

interface SelectedInputMaterialDetailProps {
  inputMaterial: IInputMaterial;
  onRemoveInputMaterial: () => void;
}

const SelectedInputMaterialDetail = ({
  inputMaterial,
  onRemoveInputMaterial,
}: SelectedInputMaterialDetailProps) => {
  return (
    <div className='flex flex-row justify-content-between'>
      <div className='flex flex-column'>
        {inputMaterial?.product_cid && (
          <Tag
            rounded
            className='font-medium w-fit'
            style={{ backgroundColor: '#e0e5ea66', color: '#6E798C' }}
          >
            {inputMaterial?.product_cid}
          </Tag>
        )}
        <span className='text-2xl font-medium mb-0'>{inputMaterial?.material_name}</span>
        <RemoveProcessButton
          onClick={() => {
            onRemoveInputMaterial();
          }}
        />
      </div>

      <EmissionValueWithSuffix
        emissionValue={inputMaterial?.pcf_excluding_biogenic}
        declaredUnit={inputMaterial?.declared_unit}
        unitaryProductAmount={inputMaterial?.unitary_product_amount}
        emissionSymbol={EmissionSymbol.KG_CO2E}
        abbreviateUnit={true}
        emissionValueDecimals={6}
        numericalValueTextClassName='text-2xl font-bold'
        suffixTextClassName='text-gray-900'
      />
    </div>
  );
};

export default SelectedInputMaterialDetail;
